import { useEffect } from "react";

const LOCK_CLASS = "ax-modal-open";
const LOCK_COUNT_ATTR = "data-ax-modal-locks";

const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked || typeof document === "undefined") return undefined;

    const { body, documentElement } = document;
    const activeLocks = Number(body.getAttribute(LOCK_COUNT_ATTR) || 0) + 1;

    body.setAttribute(LOCK_COUNT_ATTR, String(activeLocks));
    body.classList.add(LOCK_CLASS);
    documentElement.classList.add(LOCK_CLASS);

    return () => {
      const nextLocks = Math.max(Number(body.getAttribute(LOCK_COUNT_ATTR) || 1) - 1, 0);

      if (nextLocks === 0) {
        body.removeAttribute(LOCK_COUNT_ATTR);
        body.classList.remove(LOCK_CLASS);
        documentElement.classList.remove(LOCK_CLASS);
        return;
      }

      body.setAttribute(LOCK_COUNT_ATTR, String(nextLocks));
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
